import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, realUser } = useUser();

  // Sesión real (no la simulación “ver como”)
  if (!realUser) {
    return <Navigate to="/login" replace />;
  }

  if (
    Array.isArray(allowedRoles) &&
    allowedRoles.length > 0 &&
    !allowedRoles.includes(user?.tipo_usuario)
  ) {
    return <Navigate to="/inicio" replace />;
  }

  return children;
};

export default ProtectedRoute;